<div class="chart-bin">
</div>
<div class="chart-linear">
</div>
